import React from 'react'
import { Tabs,Tab } from 'react-bootstrap'
import BestRated from '../../../BestRated/BestRated'
import NewArrivals from '../../../NewArrivals/NewArrivals'
import OnSale from '../../../OnSale/OnSale'

const ITProductsCarousel = () => {
  return (
    <>
     <Tabs defaultActiveKey="NewArrivals" id="uncontrolled-tab-example" className="mb-3" variant="pills">
                <Tab eventKey="NewArrivals" title="NewArrivals" >
                    <div className="resp-tabs-container">
                        <div className="resp-tab-content-active">
                            <NewArrivals />
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="OnSale" title="OnSale">
                    <div className="resp-tabs-container">
                        <div className="resp-tab-content-active">
                            <OnSale />
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="Best Rated" title="Best Rated">
                    
                                <BestRated />
                </Tab>
            </Tabs>
    </>
  )
}

export default ITProductsCarousel